import { GET_QUESTION_SET_DETAILS } from "./types";
import global from "../global";

// Fetch List of Flashcards
const questionSetEndpoint = "rest_get_questionset.php";
export const getQuestionSetDetails = (params) => (dispatch, getState, Api) => {
  // FLAG-GETURL
  console.log("getQuestionSetDetails");
  console.log(questionSetEndpoint + params);
  return Api.get(questionSetEndpoint + params).then((response) => {
    // console.log("payload...");
    // console.log(response.data);
    let today = new Date();
    global.config.dQSLoaded = today.toISOString();        
    dispatch({
      type: GET_QUESTION_SET_DETAILS,
      payload: response.data,
    });
    return response;
  });
};
